import React from "react";
import { motion } from "framer-motion";
import { Star, Shield as ShieldIcon } from "lucide-react";

const POSITION_COLORS = {
  GK:  "text-emerald-400 border-emerald-400/40 bg-emerald-400/10",
  DEF: "text-sky-400 border-sky-400/40 bg-sky-400/10",
  MID: "text-pshl-gold border-pshl-gold/40 bg-pshl-gold/10",
  FWD: "text-pshl-red border-pshl-red/40 bg-pshl-red/10",
};

export default function PlayerCard({ player, team, index = 0 }) {
  const posClass = POSITION_COLORS[player.position] || "text-white border-white/20 bg-white/5";
  return (
    <motion.div
      initial={{ opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.4, delay: (index % 12) * 0.03 }}
      whileHover={{ y: -3 }}
      data-testid={`player-card-${player.id}`}
      className="group relative bg-pshl-surface border border-white/10 hover:border-pshl-electric transition-colors p-5 overflow-hidden"
    >
      <div
        className="absolute -bottom-12 -right-12 h-36 w-36 rounded-full blur-3xl opacity-25 group-hover:opacity-50 transition-opacity"
        style={{ background: team?.primary || "#0055FF" }}
      />
      <div className="relative flex items-start justify-between">
        <div>
          <div className={`inline-flex items-center px-2 py-0.5 text-[10px] font-display uppercase tracking-[0.18em] border ${posClass}`}>
            {player.position}
          </div>
          {player.captain && (
            <div className="ml-2 inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.2em] font-display text-pshl-gold">
              <Star className="h-3 w-3 fill-pshl-gold text-pshl-gold" /> Captain
            </div>
          )}
        </div>
        <div className="text-right">
          <div className="font-mono text-3xl text-white leading-none">#{String(player.jersey).padStart(2, "0")}</div>
        </div>
      </div>

      <div className="relative mt-4">
        <div className="font-display text-xl text-white leading-tight">{player.first_name}</div>
        <div className="font-display text-xl text-white leading-tight">{player.last_name}</div>
        {team && <div className="text-[10px] uppercase tracking-[0.22em] text-white/50 mt-1">{team.name}</div>}
      </div>

      <div className="relative mt-5 grid grid-cols-2 gap-3 text-xs">
        <div>
          <div className="text-[10px] uppercase tracking-[0.22em] text-white/50">Age</div>
          <div className="font-mono text-white text-base">{player.age}</div>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-[0.22em] text-white/50">PSHL8 Rating</div>
          <div className="font-display text-pshl-electric text-xl">{player.rating}</div>
        </div>
      </div>
    </motion.div>
  );
}
